// import GeoMoverDB from '@/db/indexeddb'

export default {
  setActiveStopCommand ({ commit }, payload) {
    commit('SET_ACTIVE_STOP_COMMAND', payload)
  },
  setActiveLanguage ({ commit }, payload) {
    commit('SET_ACTIVE_LANGUAGE', payload)
  }
}
